import Image from 'next/image'
import Link from 'next/link'
import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'

import reportAnalytics from '../../plebiscito/components/plebiscito/reportAnalytics'

interface IHeader {
  className?: string
}

const Header = ({ className }: IHeader) => {
  return (
    <Wrapper className={className}>
      <Link
        href="/"
        passHref
      >
        <Image
          alt="decidechile"
          height="47"
          priority
          src="/images/decidechile.svg"
          width="148"
        />
      </Link>

      <LinkBannerDesktop
        href="https://info.unholster.com/suscribirse-noticias"
        onClick={() => reportAnalytics('clicked_banner', "https://info.unholster.com/suscribirse-noticias")}
        passHref
        target="_blank"
      >
        <Image
          alt="banner-unholster-desktop"
          height={76}
          src="/banners/DC_Banner_Unholster.gif"
          width={(47 / 53) * 565}
        />
      </LinkBannerDesktop>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  max-width: ${spaces.maxContent};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spaces.xs};
  padding-right: 0;
  @media (max-width: ${spaces.tabletBreakpoint}) {
    margin-top: 10px;
  }
`
const LinkBannerDesktop = styled(Link)`
  @media (max-width: ${spaces.tabletBreakpoint}) {
    pointer-events: none;
    display: none;
  }
`

export default Header
